import React from 'react';
import { View } from 'react-native';
import CommerceActionProps from 'types/components/CommerceActionProps';
import OrderContext from 'contexts/OrderContext';
import { useTranslation } from 'react-i18next';
import BottomSheet from './BottomSheet';
import BottomSheetButton from './BottomSheetButton';

export default ({ commerce, navigation, setShowMenuModalByCommerce }: CommerceActionProps): JSX.Element => {
  const { currentVenue, setCurrentCommerce } = React.useContext(OrderContext);
  const { t } = useTranslation();

  const commerceActions: any[] = React.useMemo(() => {
    return [
      {
        name: t('orders'),
        icon: 'shopping-cart',
        onPress: () => {
          setShowMenuModalByCommerce('');
          navigation.navigate('OrdersScreen');
        },
      },
      {
        name: t('stock'),
        icon: 'shopping-basket',
        onPress: () => {
          setShowMenuModalByCommerce('');
          setCurrentCommerce(commerce);
          navigation.navigate('BillingScreen');
        },
      },
      {
        name: t('visualize'),
        icon: 'ondemand-video',
        onPress: () => {
          setShowMenuModalByCommerce('');
          navigation.navigate('VisualizationScreen');
        },
      },
    ];
  }, [commerce]);

  const renderCommerceActions = (): JSX.Element => {
    return (
      <View>
        {commerceActions.map((action, index) => {
          return (
            <BottomSheetButton
              key={index}
              fillColor={currentVenue?.appColor ?? '#001C47'}
              iconName={action.icon}
              description={action.name}
              onPress={() => {
                action.onPress();
              }}
            />
          );
        })}
      </View>
    );
  }

  return (
    <BottomSheet 
      isBottomSheetVisible={commerce != null} 
      setIsBottomSheetVisible={() => setShowMenuModalByCommerce('')}
      title={t('navigate-to')}
      children={renderCommerceActions()}
    />
  );
};
